import { render, staticRenderFns } from "./PlusDiamondSvg.vue?vue&type=template&id=2d48db75&"
import script from "./PlusDiamondSvg.vue?vue&type=script&lang=ts&"
export * from "./PlusDiamondSvg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports